import { ItemTemplateEntityWithSchema } from '@/types/api';

import { DefaultItemForm, ItemFormData } from './forms';

export interface ItemFormProps {
  template: Pick<
    ItemTemplateEntityWithSchema,
    | 'name'
    | 'templateKey'
    | 'jsonSchema'
    | 'uiSchema'
    | 'itemTypeId'
    | 'constructionTypeIds'
    | 'isBoardItem'
  > &
    Partial<Pick<ItemTemplateEntityWithSchema, 'lastItemNumber' | 'projectRoleTags'>>;
  onSubmit?: (data: any) => void | Promise<void>;
  onChange?: (data: any) => void;
  onDirtyChange?: (isDirty: boolean) => void;
  initialData?: ItemFormData;
  disabled?: boolean;
  mode?: 'editMode' | 'previewMode';
  formId?: string;
}

// Example of how to use the custom ItemAttribute widget
export const ItemForm = ({
  template,
  onSubmit,
  onChange,
  onDirtyChange,
  disabled,
  initialData,
  mode,
  formId,
}: ItemFormProps) => {
  const handleSubmit = (data: any) => {
    void onSubmit?.(data);
  };

  const handleChange = (data: any) => {
    onChange?.(data);
  };

  return (
    <DefaultItemForm
      itemTemplate={template}
      onChange={handleChange}
      onDirtyChange={onDirtyChange}
      onSubmit={handleSubmit}
      disabled={disabled}
      initialData={initialData}
      mode={mode}
      formId={formId}
    />
  );

  // return (
  //   <Form
  //     schema={template.jsonSchema}
  //     uiSchema={template.uiSchema}
  //     fields={customFields}
  //     onSubmit={handleSubmit}
  //     onChange={handleChange}
  //     validator={validator}
  //   />
  // );
};
